module.exports = __webpack_public_path__ + "img/RENTRER_SEUL_AUCUN_VIOLET.d1ecc2c3.svg";